import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { CmsConfig, DeferLoadingStrategy, I18nModule, provideDefaultConfig } from '@spartacus/core';
import { MediaModule } from '@spartacus/storefront';
import { SharedModule } from 'src/app/shared/shared.module';
import { ProductImageModalComponent } from './product-image-modal.component';
@NgModule({
  imports: [CommonModule, MatIconModule, I18nModule, MediaModule, SharedModule, ProductImageModalComponent],
  providers: [
    provideDefaultConfig(<CmsConfig>{
      cmsComponents: {
        ProductImageModalComponent: {
          component: ProductImageModalComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
        },
      },
    }),
  ],
  exports: [ProductImageModalComponent],
})
export class ProductImageModalModule {}
